import React, { Component } from 'react';
import _ from 'lodash';
import config from '../config';
import {
    Link,
    Redirect
} from "react-router-dom";
import {Formik} from "formik";
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {Modal} from "../components/Modal";
import JsonEditorComponent from "../JsonEditorComponent";

export default class Changes extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {
            items:[]
        };
        this.init = this.init.bind(this);
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.init();
    }

    async init(request)  {
        fetcher(`${config.API()}storage/changes`)
            .then(response => response.json())
            .then(response => {
                if(response) {
                    this.setState({
                        items: response
                    })
                }
            });

    }
    showModal = (str) => {
        return ()=> {
            this.setState({show: true});
            this.setState({modalInput: str});
        }
    };

    hideModal = () => {
        this.setState({ show: false });
    };

    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }
        return (
            <div>
                <Modal show={this.state.show} handleClose={this.hideModal}>
                    <pre>{this.state.modalInput}</pre>
                </Modal>
                <div className="card shadow w100">
                    <div className="card-header py-3"><h2 className="m-0 font-weight-bold l"> Changes</h2></div>
                    <div className="card-body small">
                        <div className="form-group row">
                            <div className="col-sm-1">
                                Version
                            </div>
                            <div className="col-sm-2">
                                DateTime
                            </div>
                            <div className="col-sm-2">
                                Login
                            </div>
                            <div className="col-sm-5">
                                Collection changes
                            </div>
                            <div className="col-sm-1">
                                Old
                            </div>
                            <div className="col-sm-1">
                                New
                            </div>
                        </div>
                        {this.state.items.map((item, i) => (
                            <div className="form-group row mb-1" key={`item-${i}`}>
                                <div className="col-sm-1">
                                    {item.adminVersion || 0}
                                </div>
                                <div className="col-sm-2">
                                    {item.createdAt}
                                </div>
                                <div className="col-sm-2">
                                    {item.login}
                                </div>
                                <div className="col-sm-5">
                                    <Link to={`${item.collection}/${item.id}`}>{item.collection}/{item.newdata && item.newdata.title}</Link> [{item.changes &&Array.isArray(item.changes) && item.changes.join(", ")}]
                                </div>
                                <div className="col-sm-1">
                                    <JsonEditorComponent mystyle="noBtn" className="cp" data={item.olddata}/>
                                </div>
                                <div className="col-sm-1">
                                    <JsonEditorComponent mystyle="noBtn" className="cp" data={item.newdata}/>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        );
    }
}